import React from 'react';
import { Inline } from '@99designs/emu';
import { IconButton } from '@99designs/emu';
import {
    IconMaximize1,
    IconMinimize1,
    IconView1,
    IconZoomIn1,
    IconZoomOut1,
} from '@99designs/icons';

interface ViewControlsProps {
    isPresentationMode: boolean;
    handleMinimize: () => void;
    handleMaximize: () => void;
    zoomIn: () => void;
    zoomOut: () => void;
    canZoomIn: boolean;
    canZoomOut: boolean;
    isPrintPreviewLoading?: boolean;
    isShowingPrintPreview?: boolean;
    onShowPrintPreview?: () => void;
}

function ViewControls({
    isPresentationMode,
    handleMinimize,
    handleMaximize,
    zoomIn,
    zoomOut,
    canZoomIn,
    canZoomOut,
    isPrintPreviewLoading,
    isShowingPrintPreview,
    onShowPrintPreview,
}: ViewControlsProps) {
    return (
        <Inline space="none">
            {onShowPrintPreview && (
                <IconButton
                    aria-label={
                        isShowingPrintPreview ? __('Exit print preview') : __('Show print preview')
                    }
                    onClick={onShowPrintPreview}
                    loading={isPrintPreviewLoading}
                    selected={isShowingPrintPreview}
                    icon={IconView1}
                    appearance="transparent"
                />
            )}
            <IconButton
                aria-label={__('Zoom in (+)')}
                onClick={zoomIn}
                disabled={!canZoomIn}
                icon={IconZoomIn1}
                appearance="transparent"
            />
            <IconButton
                onClick={zoomOut}
                aria-label={__('Zoom out (-)')}
                disabled={!canZoomOut}
                icon={IconZoomOut1}
                appearance="transparent"
            />
            {isPresentationMode ? (
                <IconButton
                    key="minimizeBtn"
                    aria-label={__('Exit presentation mode')}
                    onClick={handleMinimize}
                    icon={IconMinimize1}
                    appearance="transparent"
                />
            ) : (
                <IconButton
                    key="maximizeBtn"
                    aria-label={__('Presentation mode, fullscreen')}
                    onClick={handleMaximize}
                    icon={IconMaximize1}
                    appearance="transparent"
                />
            )}
        </Inline>
    );
}

export default ViewControls;
